__turbopack_context__.v({
  "tab": "tss5nq_tab",
  "tab-active": "tss5nq_tab-active",
});
